.section {
    margin-top: 32px;
    padding-bottom: 24px;
}
